import { Label } from 'components/Label/Label';
import './OrganizationModules.scss';
import { Table, TableBody, TableCell, TableHead, TableRow } from '@trackman/web-shared-components';
import { ReactComponent as Medal } from 'images/icons/MedalThin.svg';

export const OrganizationModules = ({ organizationSpecificModuleNames }: { organizationSpecificModuleNames: string[] }) => {
  return (
    <div className='tmu-table-wrapper admin-edit-section organization-modules'>
      <Table className='tmu-table admin-table'>
        <TableHead>
          <TableRow>
            <TableCell>
              <Label label='Organization specific modules' className='organization-modules--label'></Label>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {organizationSpecificModuleNames.length &&
            organizationSpecificModuleNames.map((moduleName, index) => {
              return (
                <TableRow key={index}>
                  <TableCell className='organization-modules--table-item'>
                    <Medal />
                    {moduleName}
                  </TableCell>
                </TableRow>
              );
            })}
        </TableBody>
      </Table>
    </div>
  );
};
